import { useEffect, useState } from 'react';
import { EDGES_AWAITING_ELK_MAX_HIDE_MS } from './flowchartLayout/constants';

/**
 * Keep edges hidden until ELK has committed a layout from real measured card
 * sizes. Revealing on the first pass (default dimensions) flashes the old
 * routing, then snaps. A timeout stops a failed worker from hiding edges forever.
 */
export function useHideEdgesAwaitingElk({ isMultiCampaignMode, measuredElkSettled, taskCount }) {
  const hideEdgesAwaitingElkRaw = !isMultiCampaignMode && !measuredElkSettled && taskCount > 0;
  const [edgeRevealForced, setEdgeRevealForced] = useState(false);

  useEffect(() => {
    if (!hideEdgesAwaitingElkRaw) {
      setEdgeRevealForced(false);
      return undefined;
    }
    const timeoutId = setTimeout(() => setEdgeRevealForced(true), EDGES_AWAITING_ELK_MAX_HIDE_MS);
    return () => clearTimeout(timeoutId);
  }, [hideEdgesAwaitingElkRaw]);

  return hideEdgesAwaitingElkRaw && !edgeRevealForced;
}
